document.addEventListener("DOMContentLoaded", function() {
  // Select the product description element
  /** @type {HTMLElement | null} */
  const productDescription = /** @type {HTMLElement | null} */ (document.querySelector(".product__description"));

  if (productDescription) {
    // Find elements with the class .product_specifications
    /** @type {HTMLElement | null} */
    const productSpecs = /** @type {HTMLElement | null} */ (productDescription.querySelector(".product_specifications"));
    // Find elements with the class .about_the_artist
    /** @type {HTMLElement | null} */
    const aboutTheArtist = /** @type {HTMLElement | null} */ (productDescription.querySelector(".about_the_artist"));

    /**
     * Function to create collapsible sections
     * @param {string} title
     * @param {HTMLElement} content
     * @returns {HTMLDetailsElement}
     */
    // eslint-disable-next-line no-inner-declarations
    function createCollapsible(title, content) {
      const detailsElement = document.createElement("details");
      detailsElement.classList.add("custom-collapsible");
      const summaryElement = document.createElement("summary");
      summaryElement.classList.add("custom-summary");
      const contentElement = document.createElement("div");

      summaryElement.innerText = title;
      contentElement.innerHTML = content.innerHTML;  // Copy the HTML content

      detailsElement.appendChild(summaryElement);
      detailsElement.appendChild(contentElement);

      return detailsElement;
    }

    // Handle product specifications section
    if (productSpecs) {
      productSpecs.style.display = "none";
      const specsCollapsible = createCollapsible("Details", productSpecs);
      productDescription.appendChild(specsCollapsible);
    }

    // Handle about the artist section
    if (aboutTheArtist) {
      aboutTheArtist.style.display = "none";
      const artistCollapsible = createCollapsible("About the Maker", aboutTheArtist);
      productDescription.appendChild(artistCollapsible);
    }
  }
});
